import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export const getAttendanceColumns = (pagination = { current: 1, pageSize: 10 }) => [
  {
    title: "No.",
    key: "index",
    render: (_text, _record, index) =>
      (pagination.current - 1) * pagination.pageSize + index + 1,
    width: 80,
    fixed: "left",
  },
  {
    title: "Staff Name",
    dataIndex: "staff_name",
    key: "staff_name",
  },
  {
    title: "Email",
    dataIndex: "staff_email",
    key: "staff_email",
  },
  {
    title: "Role",
    dataIndex: "staff_role",
    key: "staff_role",
  },
  {
    title: "Merchant",
    dataIndex: "staff_merchant_name",
    key: "staff_merchant_name",
  },
  {
    title: "Login Time",
    dataIndex: "staff_login_time",
    key: "staff_login_time",
    render: (text) =>
      text && dayjs(text).isValid()
        ? dayjs(text).format("DD-MM-YYYY HH:mm:ss")
        : "",
  },
  {
    title: "Logout Time",
    dataIndex: "staff_logout_time",
    key: "staff_logout_time",
    render: (text) =>
      text && dayjs(text).isValid()
        ? dayjs(text).format("DD-MM-YYYY HH:mm:ss")
        : "",
  },
  {
    title: "Total Working Hour",
    key: "total_working_hour",
    render: (_, record) => {
      const login = dayjs(record.staff_login_time);
      const logout = dayjs(record.staff_logout_time);
      if (!login.isValid() || !logout.isValid() || logout.isBefore(login)) return "-";

      const diffMs = logout.diff(login);
      const durationObj = dayjs.duration(diffMs);

      const hours = durationObj.hours();
      const minutes = durationObj.minutes();
      return `${hours} hour${hours !== 1 ? "s" : ""} ${minutes} minute${minutes !== 1 ? "s" : ""}`;
    },
  },
  {
    title: "Over Time Hours (Total Hours - 9)",
    key: "overtime_hour",
    render: (_, record) => {
      const login = dayjs(record.staff_login_time);
      const logout = dayjs(record.staff_logout_time);
      if (!login.isValid() || !logout.isValid() || logout.isBefore(login)) return "-";

      const diffMs = logout.diff(login);
      const durationObj = dayjs.duration(diffMs);

      if (durationObj.asHours() <= 9) return "00:00:00";

      const overtimeMs = diffMs - dayjs.duration(9, "hours").asMilliseconds();
      const overtime = dayjs.duration(overtimeMs);

      const hours = String(Math.floor(overtime.asHours())).padStart(2, "0");
      const minutes = String(overtime.minutes()).padStart(2, "0");
      const seconds = String(overtime.seconds()).padStart(2, "0");

      return (
        <span style={{ color: "red" }}>{`${hours}:${minutes}:${seconds}`}</span>
      );
    },
  },
];